export function getExtension(item): string {
    const name = typeof item === 'string' ? item : item?.name;
    if (!name) {
        return '';
    }

    const index = name.lastIndexOf('.');

    return index !== -1 ? name.slice(Math.max(0, index + 1)) : '';
};
